interface LegendTooltipProps {
  date: string
  selectedCategory: string
  currentCompany: {
    name: string
    score: string
    color: string
    ai_generated?: boolean
  }
  hoveredCompany: {
    name: string
    score: string
    color: string
    ai_generated?: boolean
  }
}

export const LegendTooltip = ({
  date,
  currentCompany,
  selectedCategory,
  hoveredCompany,
}: LegendTooltipProps) => {
  const currentScore = parseFloat(currentCompany.score)
  const hoveredScore = parseFloat(hoveredCompany.score)
  const difference = (
    ((currentScore - hoveredScore) / hoveredScore) *
    100
  ).toFixed(1)
  const isPositive = currentScore > hoveredScore

  const CompanyRow = ({
    company,
    score,
  }: {
    company: typeof currentCompany
    score: number
  }) => (
    <div className="flex items-center justify-between group transition-all duration-200">
      <div className="flex items-center gap-2">
        <div
          className="w-1 h-4 rounded-full"
          style={{ backgroundColor: company.color }}
        />
        <div className="flex items-center gap-system-xs">
          <span className="text-base text-white/90 font-medium capitalize">
            {company.name}
          </span>
          {company.ai_generated && (
            <span className="text-[10px] font-medium bg-system-blue-700/50 text-system-blue-300 px-system-xxs py-system-xxs rounded">
              AI
            </span>
          )}
        </div>
      </div>
      <span className="text-base font-semibold text-white ml-system-sm pl-system-sm">
        {score.toFixed(1)}
      </span>
    </div>
  )

  return (
    <div className="bg-system-blue-900/90 backdrop-blur-sm p-system-md rounded-system-xl shadow-xl border-2 border-system-blue-700">
      <div className="flex flex-col mb-system-sm pb-system-xs border-b-[2px] border-system-blue-700">
        <div className="flex items-center justify-between">
          <p className="text-white font-medium text-lg">{date}</p>
          <div
            className={`px-system-sm ml-system-sm rounded-full ${isPositive ? "bg-green/20" : "bg-red/20"}`}
          >
            <span
              className={`text-sm leading-none font-semibold ${isPositive ? "text-green" : "text-red"}`}
            >
              {isPositive ? "+" : ""}
              {difference}%
            </span>
          </div>
        </div>
        <p className="text-white/60 text-sm mt-system-xxs capitalize">
          {selectedCategory}
        </p>
      </div>
      <div className="space-y-system-xs">
        <CompanyRow company={currentCompany} score={currentScore} />
        <CompanyRow company={hoveredCompany} score={hoveredScore} />
      </div>
    </div>
  )
}
